import { Illuminate } from "@graylog/enterprise-api";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { deserializePacks, buildIlluminateQuery } from "illuminate/components/content-hub/utils";
export async function fetchHubLatestPacks(searchParams) {
  var _a;
  const params = [
    `page=${searchParams.page}`,
    `per_page=${searchParams.pageSize}`,
    "include_deps=false",
    `sort=${searchParams.sort.attributeId}`,
    `direction=${searchParams.sort.direction}`
  ];
  if (searchParams.query) params.push(`query=${encodeURI(searchParams.query)}`);
  const filters = (_a = searchParams.filters.toJS()) != null ? _a : {};
  if (filters && Object.keys(filters).length > 0) params.push(`${encodeURI(buildIlluminateQuery(filters))}`);
  return Promise.all([
    Illuminate.packFilterOptions({
      fields: ["tags", "category", "input_type"]
    }),
    fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.latest.searchPacksPaginated(params.join("&")).url))
  ]).then(deserializePacks);
}
export const packEntitiesKeyFn = (searchParams) => ["packs", "search", searchParams];
export const fetchLatestPacksForTag = async (page, perPage, tag, query = null, filters = {}, includeDeps = false, sort = { attributeId: void 0, direction: void 0 }) => {
  const params = [
    `page=${page}`,
    `per_page=${perPage}`,
    `include_deps=${includeDeps}`,
    `sort=${sort.attributeId}`,
    `direction=${sort.direction}`
  ];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`${encodeURI(buildIlluminateQuery(filters))}`);
  }
  return fetch(
    "GET",
    qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.latest.searchPacksForTagPaginated(tag, params.join("&")).url)
  );
};
export const fetchThreatWidgetLatestPack = async ({
  page,
  includeDeps,
  query,
  filters,
  sort,
  pageSize,
  tag
}) => {
  const response = await fetchLatestPacksForTag(page, pageSize, tag, query, filters.toJS(), includeDeps, sort);
  return deserializePacks([{ tags: [], category: [], input_types: [] }, response]);
};
export async function fetchAllLatestBundlePacks() {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.latest.searchPacks().url));
}
export const fetchPacksNoPaginated = async (filters) => {
  const params = Object.keys(filters).map(
    (key) => `${key}=${Array.isArray(filters[key]) ? filters[key].join(",") : filters[key]}`
  );
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.Illuminate.bundles.latest.searchPacks(params.join("&")).url));
};
export const fetchPacksSummary = async () => Illuminate.latestSummary({ requestShouldExtendSession: false });
export const latestEnablePacks = async ({ requestObject }) => {
  const { url } = EnterpriseApiRoutes.Illuminate.bundles.latest.enablePacks();
  return fetch("POST", qualifyUrl(url), requestObject);
};
export const latestDisablePacks = async ({ requestObject }) => {
  const { url } = EnterpriseApiRoutes.Illuminate.bundles.latest.disablePacks();
  return fetch("POST", qualifyUrl(url), requestObject);
};
